/*eslint-disable*/
import Flickity from 'flickity'
import vsbl from 'vsbl'
// FIXME: When importing flickity globally on theme.liquid it breaks importing it within single files!
//        see: https://github.com/metafizzy/flickity/issues/484

export default corporateGiftingBenefits => {
  const slideshow = corporateGiftingBenefits.querySelector('.js-corporate-gifting-benefits-slides')
  vsbl(corporateGiftingBenefits)(() => {
    corporateGiftingBenefits.classList.add('is-visible')
  })
  if (slideshow) {
    const flkty = new Flickity(slideshow, {
      contain: true,
      prevNextButtons: false,
      watchCSS: true,
      autoPlay: 4000
    })

    flkty.on('dragStart', (event, pointer) => {
      document.ontouchmove = e => e.preventDefault()
    })
    flkty.on('dragEnd', (event, pointer) => {
      document.ontouchmove = e => true
    })

    setTimeout(() => {
      flkty.resize()
    }, 1500)
  }
}


// WEBPACK FOOTER //
// ./src/scripts/components/corporate-gifting-benefits.js